module.exports = __webpack_public_path__ + "static/img/banner-csr-05.2f8ac26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-05.jpg
// module id = Fsay
// module chunks = 99